import { isMarketingPath } from "~/utils/isDashboardPage";

/** Load portal/auth styles only off marketing routes (keeps marketing CSS slim). */
export default defineNuxtPlugin(() => {
  let portalLoaded = false;
  let editorialLoaded = false;
  let datepickerLoaded = false;

  const loadPortalStyles = (path: string) => {
    if (isMarketingPath(path)) return;

    if (!portalLoaded) {
      portalLoaded = true;
      void import("~/assets/scss/portal-entry.scss");
    }

    if (!editorialLoaded) {
      editorialLoaded = true;
      void import("~/assets/scss/editorial-entry.scss");
    }

    if (!datepickerLoaded) {
      datepickerLoaded = true;
      void import("@vuepic/vue-datepicker/dist/main.css");
    }
  };

  loadPortalStyles(window.location.pathname);

  const router = useRouter();
  router.afterEach((to) => {
    loadPortalStyles(to.path);
  });
});
